

export default {
  locale: 'sk',
  Pagination: {
    items_per_page: '/ strana',
    jump_to: 'Choď na',
    jump_to_confirm: 'potvrdit',
    page: '',
    prev_page: 'Predchádzajúca strana',
    next_page: 'Nasledujúca strana',
    prev_5: 'Predchádzajúcich 5 strán',
    next_5: 'Nasledujúcich 5 strán',
    prev_3: 'Predchádzajúce 3 strany',
    next_3: 'Nasledujúce 3 strany',
    page_size: 'Page Size'
  },
  DatePicker: {
    lang: {
      placeholder: 'Vybrať dátum',
      rangePlaceholder: ['Od', 'Do'],
      locale: 'sk_SK',
      today: 'Dnes',
      now: 'Teraz',
      backToToday: 'Späť na dnes',
      ok: 'Ok',
      clear: 'Vymazať',
      month: 'Mesiac',
      year: 'Rok',
      timeSelect: 'Vybrať čas',
      dateSelect: 'Vybrať dátum',
      monthSelect: 'Vybrať mesiac',
      yearSelect: 'Vybrať rok',
      decadeSelect: 'Vybrať dekádu',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Predchádzajúci mesiac (PageUp)',
      nextMonth: 'Nasledujúci mesiac (PageDown)',
      previousYear: 'Predchádzajúci rok (Control + left)',
      nextYear: 'Nasledujúci rok (Control + right)',
      previousDecade: 'Predchádzajúca dekáda',
      nextDecade: 'Nasledujúca dekáda',
      previousCentury: 'Predchádzajúce storočie',
      nextCentury: 'Nasledujúce storočie'
    },
    timePickerLocale: {
      placeholder: 'Vybrať čas'
    }
  },
  TimePicker: {
    placeholder: 'Vybrať čas'
  },
  Calendar: {
    lang: {
      placeholder: 'Vybrať dátum',
      rangePlaceholder: ['Od', 'Do'],
      locale: 'sk_SK',
      today: 'Dnes',
      now: 'Teraz',
      backToToday: 'Späť na dnes',
      ok: 'Ok',
      clear: 'Vymazať',
      month: 'Mesiac',
      year: 'Rok',
      timeSelect: 'Vybrať čas',
      dateSelect: 'Vybrať dátum',
      monthSelect: 'Vybrať mesiac',
      yearSelect: 'Vybrať rok',
      decadeSelect: 'Vybrať dekádu',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Predchádzajúci mesiac (PageUp)',
      nextMonth: 'Nasledujúci mesiac (PageDown)',
      previousYear: 'Predchádzajúci rok (Control + left)',
      nextYear: 'Nasledujúci rok (Control + right)',
      previousDecade: 'Predchádzajúca dekáda',
      nextDecade: 'Nasledujúca dekáda',
      previousCentury: 'Predchádzajúce storočie',
      nextCentury: 'Nasledujúce storočie'
    },
    timePickerLocale: {
      placeholder: 'Vybrať čas'
    }
  },
  global: {
    placeholder: 'Prosím vyberte'
  },
  Table: {
    filterTitle: 'Filter',
    filterConfirm: 'OK',
    filterReset: 'Obnoviť',
    selectAll: 'Vybrať všetko',
    selectInvert: 'Vybrať opačné',
    sortTitle: 'Zoradiť',
    expand: 'Rozbaliť riadok',
    collapse: 'Zbaliť riadok'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Zrušiť',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Zrušiť'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Vyhľadávanie',
    itemUnit: 'položka',
    itemsUnit: 'položiek'
  },
  Upload: {
    uploading: 'Nahrávanie...',
    removeFile: 'Odstrániť súbor',
    uploadError: 'Chyba pri nahrávaní',
    previewFile: 'Zobraziť súbor',
    downloadFile: 'Stiahnuť súbor'
  },
  Empty: {
    description: 'Žiadne dáta'
  },
  Icon: {
    icon: 'ikona'
  },
  Text: {
    edit: 'Upraviť',
    copy: 'Kopírovať',
    copied: 'Skopírované',
    expand: 'Zväčšiť'
  },
  PageHeader: {
    back: 'Späť'
  }
};
